import { render, staticRenderFns } from "./supplierTransactions.vue?vue&type=template&id=7f855005&"
import script from "./supplierTransactions.vue?vue&type=script&lang=js&"
export * from "./supplierTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports